import { Redirect, Slot, usePathname, useNumberParams, useRouter } from 'zens-router'
import { AccessType, PermissionContext, RoleType, useProfile, useStore } from 'zens-store'
import { usePermissions } from '@dms/hook'
import { titleForRole } from '@dms/helper'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'

export default function AppLayout() {
  const { auth } = useStore()
  const [{ companyId, workspaceId, productId }] = useNumberParams()
  const pathname = usePathname()
  const profile = useProfile()
  const role = profile.data?.roleForCompany(companyId)
  const { hasPermission } = usePermissions(companyId)
  const { isSignedIn, isLoaded } = auth
  const { t } = useTranslation()
  const router = useRouter()

  const contextForPath = (pathname: string) => {
    if (pathname === '/') return 'home'
    else if (/^\/companies\/\d+\/assistant/.test(pathname)) return 'insights'
    else if (/^\/companies\/\d+\/insights\/\d+\/buildings\/\d+\/floors\/\d+\/live/.test(pathname)) return 'kiosk'
    else if (/^\/companies\/\d+\/insights/.test(pathname)) return 'insights'
    else if (/^\/companies\/\d+\/locations\/\d+\/buildings\/\d+\/floors/.test(pathname)) return 'floor'
    else if (/^\/companies\/\d+\/locations\/\d+\/buildings/.test(pathname)) return 'building'
    else if (/^\/companies\/\d+\/locations/.test(pathname)) return 'location'
    else if (/^\/companies\/\d+\/products/.test(pathname)) return 'product'
    else if (/^\/companies\/\d+\/users/.test(pathname)) return 'user'
    else if (/^\/companies\/\d+\/workspaces/.test(pathname)) return 'workspace'
    else if (/^\/companies\/\d+\/feedback/.test(pathname)) {
      if (productId) return 'product'
      else if (workspaceId) return 'workspace'
      return 'location'
    } else if (/^\/companies\/\d+\/.*/.test(pathname)) return 'company'
    else if (/^\/workspacetypes/.test(pathname)) return 'settings'
    else return pathname
  }

  const accessForPath = (pathname: string) => {
    if (pathname.endsWith('/add')) return AccessType.Create
    else if (pathname.endsWith('/edit')) return AccessType.Update
    else return AccessType.Read
  }

  const context = contextForPath(pathname)
  const access = accessForPath(pathname)
  const permission = hasPermission(access, context as PermissionContext)

  useEffect(() => {
    if (!isLoaded || !profile.isFetched) return
    console.debug(
      `PERMISSION: ${
        access === AccessType.Create ? 'Create' : access === AccessType.Update ? 'Update' : 'Read'
      } ${context} ${permission ? 'allowed' : 'forbidden'} for ${titleForRole(role, t)} (${pathname})`,
    )
    if (!permission) {
      router.push('/forbidden')
    }
  }, [isLoaded, permission, !profile.isFetched])

  if (!isLoaded || (isSignedIn && !profile.isFetched)) return null
  if (!isSignedIn) {
    return <Redirect href="/email" />
  }
  return <Slot />
}
